import { Task } from '@/api/types';
import SimplePage from '@/components/structure/SimplePage';
import EditableTask from '@/components/tasks/editing/EditableTask';
import TaskComponent from '@/components/tasks/Task';
import React from 'react';

// Import your components here
// import ExampleComponent from '../components/ExampleComponent';

const Sandbox: React.FC = () => {
  const promptSet = [
    {
      name: "Full Name",
      description: "Enter your complete name",
      type: "single-line-textbox" as const,
      options: { "max-characters": 15 }
    },
    {
      name: "Preferred Contact Method",
      description: "How would you like us to contact you?",
      type: "multiple-choice" as const,
      options: {
        choices: [
          { name: "Email", value: "email" },
          { name: "Phone", value: "phone" }
        ]
      }
    }
  ];

  return (
    <SimplePage title="Sandbox" className="p-4">
      
      <p>This page is for testing out site components.</p>

      <hr className="mb-8 mt-8 border border-gray-200" />

      <h2 className="text-xl font-semibold mb-4">Fillable Task Example</h2>
      
      <TaskComponent 
        title="User Registration Survey"
        description="Please complete the following information to register"
        prompts={promptSet}
      />

      <hr className="mb-8 mt-8 border border-gray-200" />

      <h2 className="text-xl font-semibold mb-4">Editable Task Example</h2>

      <EditableTask
        task={{
          title: "Sample Editable Task",
          description: "This is a task you can edit.",
          instructions: "<p>Provide detailed instructions here.</p>",
          prompts: promptSet
        } as Task}
      />

    </SimplePage>
  );
};

export default Sandbox;
